/*****************************************************************************************
 * 설명 : 로그인
 * 작성자 :
 * 작성일 :
*****************************************************************************************/
import Button from '@mui/material/Button';
import { useFormik } from 'formik';
import { useEffect } from "react";
import { Cookies } from 'react-cookie';
import { useDispatch } from 'react-redux';
import * as Yup from "yup";

import { CheckBoxEx, InputEx } from 'components/inputEx';
import alertMsg from 'components/message';

import { setUserInfo } from 'reducers/userReducer';

import { Restful } from 'service/restful';

import HeaderLogin from "pages/admin/layout/headerLogin";
import './login.scss';

/*****************************************************************************************
 * 설명 : 함수 선언
*****************************************************************************************/
function Login(props) {

  /***************************************************************************************
   * 설명 : 변수 선언부
  ***************************************************************************************/
  const cookies = new Cookies()
  const dispatch = useDispatch()

  const [getApi] = Restful();

  const formik = useFormik({
    initialValues: {
      adminId: '',
      adminPw: '',
      saveId: false
    },
    validationSchema: Yup.object().shape({
      adminId: Yup.string().min(1, '최소1자').max(20, "20자리").required('필수'),
      adminPw: Yup.string().min(1, '최소1자').max(20, "20자리").required('필수')
    }),
    onSubmit: (values) => {

      let params = {
        program: 'admin',
        service: 'member',
        version: '1.0',
        action: 'login',
        adminId: values.adminId,
        adminPw: values.adminPw,
        saveId: false
      }

      getApi("post", params).then( response => {
        if( response !== undefined && response.data.result ) {
          // 아이디 저장
          if (values.saveId)
            cookies.set('ACIMSID', values.adminId);
          else
            cookies.remove('ACIMSID');

          alertMsg(response.data.message, "S", 3000);

          if( response.data.data && response.data.data.length > 0 )
            dispatch(setUserInfo(response.data.data[0]));
          else
            dispatch(setUserInfo({}));

          props.history('/admin/cert/application');

        } else {
          alertMsg(response.data.message, "E", 3000);
        }
      });
    }
  });

  /***************************************************************************************
   * 설명 : 아이디 저장 체크
  ***************************************************************************************/
  useEffect(() => {
    const id = cookies.get('ACIMSID');

    if( id !== undefined && id !== 'undefined' ) {
      formik.setFieldValue('adminId', id);
      formik.setFieldValue('saveId', true);
    }

    // eslint-disable-next-line
  }, [])

  /***************************************************************************************
   * 설명 : html 선언부
  ***************************************************************************************/
  return (
    <>
      <HeaderLogin></HeaderLogin>

      <form className="Login-admin" onSubmit={formik.handleSubmit}>
        <div className="login-wrap">
          <div className="login-logo"></div>
          <div className="inputbox">
          <InputEx
              name="adminId"
              formik={formik}
              label="아이디를 입력하세요"
              inputProps={{focus: "true"}}
              InputLabelProps={{shrink: true}}
            />
          </div>
          <div className="inputbox">
            <InputEx
              type="password"
              name="adminPw"
              formik={formik}
              label="비밀번호를 입력하세요"
              InputLabelProps={{shrink: true}}
              style={{height: '34px !important'}}
            />
          </div>
          <Button type="submit" color="primary" variant="contained" className="login-btn white">로그인</Button>
          <CheckBoxEx
            name="saveId"
            color="primary"
            formik={formik}
            className="white"
            label="아이디 저장"
          />
        </div>
      </form>
      <div className="footer-admin">
        <p className="footer-txt">CopyRight(c) 2016 KRAIA Corp. ALL RIGHTS RESERVED.</p>
      </div>
    </>
  )
}

/*****************************************************************************************
 * 설명 : default export 선언
*****************************************************************************************/
export default Login;